import React, { useState } from 'react'
import styled from 'styled-components'
import { useAssociado } from '../../../contexts/AssociadoContext'
import Button from '@taglivros/oef_componentes/build/components/button'
import Card from '@taglivros/oef_componentes/build/components/card'
import FormAlterarSenha from './FormAlterarSenha'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'

const WrapperCardSenha = styled.div`
  p {
    margin-top: 5px;
  }

  .wrapper__botao {
    margin-top: ${( { open } ) => open ? '20px' : '45px'};
  }
`

const CardSenha = () => {
  const { loadingRequisicaoSenha, postRedefinirSenhaLogado, openFormularioSenha, setToggleFormAlterarSenha } = useAssociado()
  const [ senhaAlterada, setSenhaAlterada ] = useState( {} )

  const trocarSenha = senhas => {
    setSenhaAlterada( senhas )
  }

  const redefinirSenha = async() => {
    if ( !isEmptyObject( senhaAlterada ) ) {
      const senhaAntiga = senhaAlterada[ 'senha-antiga' ]
      const senhaNova = senhaAlterada[ 'senha-nova' ]
      await postRedefinirSenhaLogado( {
        'nova_senha': senhaNova,
        'senha_atual': senhaAntiga
      } )
    }
  }

  return (
    <Card>
      <WrapperCardSenha
        open={ openFormularioSenha }
      >
        <h3>Redefinir senha</h3>
        { loadingRequisicaoSenha ?
          <InlineLoader isCenter /> :
          <>
            <p>Crie uma nova senha para sua conta.</p>
            {
              openFormularioSenha ?
                <FormAlterarSenha
                  onConfirmar={ trocarSenha }
                /> : null
            }
            <div className="wrapper__botao">
              <Button
                hasSpaceBottom={ false }
                onClick={ () => openFormularioSenha ? redefinirSenha() : setToggleFormAlterarSenha( true ) }
              >
                Criar nova senha
              </Button>
            </div>
          </>}
      </WrapperCardSenha>
    </Card>
  )
}

export default CardSenha
